import { forwardRef } from "react";
import { Input, InputProps } from "./input";

type ChatbotInputProps = Omit<InputProps, "type">;

export const ChatbotInput = forwardRef<HTMLInputElement, ChatbotInputProps>((props, ref) => {
  return (
    <Input
      {...props}
      ref={ref}
      type="text"
      inputStyleClassName="text-body-s md:text-body-s leading-none md:leading-none p-3.5 md:p-3.5 h-[42px]"
    />
  );
});

ChatbotInput.displayName = "ChatbotInput";
